import {SellerError} from './SellerError.js'

export class UpdateInstantOfferPhoneSellerError extends SellerError {
  constructor(message) {
    super(message)
    this.name = 'UpdateInstantOfferPhoneSellerError'
  }
}
